/**
 * Kingsley North - Featured Collection Product Slider
 * Matches slider behaviour from kingsleynorth.com:
 * - Looping carousel (next at end → start, prev at start → end)
 * - Dot navigation synced with slide position
 * - Prev/next always clickable; arrows on sides, dots below
 * - Optional autoplay
 * - Dot count and arrow step follow mobile vs desktop column settings (990px matches theme grid)
 */
(function () {
  'use strict';

  var DESKTOP_GRID_MQ = '(min-width: 990px)';

  function initFeaturedCollectionSlider(sliderComponent) {
    if (sliderComponent.hasAttribute('data-fc-slider-init')) return;
    sliderComponent.setAttribute('data-fc-slider-init', '');
    var columnsMobile = parseInt(sliderComponent.getAttribute('data-columns-mobile'), 10) || 1;
    var columnsDesktop = parseInt(sliderComponent.getAttribute('data-columns-desktop'), 10) || 4;
    var ariaPrefix = sliderComponent.getAttribute('data-slider-aria-label') || 'Slide';
    var dotsContainer = sliderComponent.querySelector('[data-featured-collection-dots]');
    var slider = sliderComponent.querySelector('[id^="Slider-"]');
    var prevBtn = sliderComponent.querySelector('button[name="previous"]');
    var nextBtn = sliderComponent.querySelector('button[name="next"]');
    var autoplaySpeed = parseInt(sliderComponent.getAttribute('data-autoplay-speed'), 10) || 0;
    var autoplayTimer = null;
    var mqDesktop = window.matchMedia(DESKTOP_GRID_MQ);
    var dots = [];
    var lastLayoutKey = '';
    var resizeTimer = null;

    if (!slider || !nextBtn) return;

    function getEffectiveColumns() {
      return mqDesktop.matches ? columnsDesktop : columnsMobile;
    }

    function getSlideElements() {
      return Array.from(sliderComponent.querySelectorAll('[id^="Slide-"]'));
    }

    function getPagesCount() {
      var n = getSlideElements().length;
      if (n === 0) return 0;
      var cols = getEffectiveColumns();
      if (cols < 1) cols = 1;
      return Math.ceil(n / cols);
    }

    function getSliderItems() {
      return getSlideElements().filter(function (el) {
        return el.clientWidth > 0;
      });
    }

    function getMaxScrollLeft() {
      return slider.scrollWidth - slider.clientWidth;
    }
    function isAtStart() {
      return slider.scrollLeft <= 2;
    }
    function isAtEnd() {
      var maxScroll = getMaxScrollLeft();
      return maxScroll <= 0 || slider.scrollLeft >= maxScroll - 2;
    }

    // Kingsley-style looping: keep arrows always clickable
    function allowLooping() {
      if (prevBtn) prevBtn.removeAttribute('disabled');
      if (nextBtn) nextBtn.removeAttribute('disabled');
    }
    var observer = new MutationObserver(allowLooping);
    observer.observe(sliderComponent, { attributes: true, subtree: true, attributeFilter: ['disabled'] });
    allowLooping();

    nextBtn.addEventListener('click', function (e) {
      if (isAtEnd()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      }
    }, true);

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        if (isAtStart()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          slider.scrollTo({ left: getMaxScrollLeft(), behavior: 'smooth' });
        }
      }, true);
    }

    function updateStepButtons() {
      var step = getEffectiveColumns();
      if (step < 1) step = 1;
      if (prevBtn) prevBtn.setAttribute('data-step', String(step));
      nextBtn.setAttribute('data-step', String(step));
    }

    function buildDots() {
      if (!dotsContainer) return;
      var sliderId = dotsContainer.getAttribute('data-slider-id') || slider.id;
      var pages = getPagesCount();
      dotsContainer.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'slider-counter__link slider-counter__link--dots link' + (i === 0 ? ' slider-counter__link--active' : '');
        btn.setAttribute('aria-label', ariaPrefix + ' ' + (i + 1));
        btn.setAttribute('aria-controls', sliderId);
        var span = document.createElement('span');
        span.className = 'dot';
        btn.appendChild(span);
        dotsContainer.appendChild(btn);
      }
      dots = Array.from(dotsContainer.querySelectorAll('.slider-counter__link--dots'));
    }

    function syncDotsToLayout() {
      var key = getEffectiveColumns() + ':' + getPagesCount();
      if (key !== lastLayoutKey) {
        lastLayoutKey = key;
        buildDots();
      }
      updateStepButtons();
      updateDots();
    }

    function updateDots() {
      var cols = getEffectiveColumns();
      var sliderItems = getSliderItems();
      if (sliderItems.length < 2 || dots.length === 0) return;
      var itemOffset = sliderItems[1].offsetLeft - sliderItems[0].offsetLeft;
      if (itemOffset <= 0) return;
      var currentPage = Math.round(slider.scrollLeft / itemOffset) + 1;
      var dotIndex = Math.floor((currentPage - 1) / cols);
      dotIndex = Math.max(0, Math.min(dotIndex, dots.length - 1));
      dots.forEach(function (dot, index) {
        dot.classList.toggle('slider-counter__link--active', index === dotIndex);
      });
    }

    sliderComponent.addEventListener('slideChanged', function (event) {
      var cols = getEffectiveColumns();
      var currentPage = event.detail.currentPage;
      var dotIndex = Math.floor((currentPage - 1) / cols);
      dotIndex = Math.max(0, Math.min(dotIndex, dots.length - 1));
      dots.forEach(function (dot, index) {
        dot.classList.toggle('slider-counter__link--active', index === dotIndex);
      });
    });

    slider.addEventListener('scroll', function () {
      requestAnimationFrame(updateDots);
    });

    if (dotsContainer && !dotsContainer.dataset.kingsleyDotsDelegated) {
      dotsContainer.dataset.kingsleyDotsDelegated = 'true';
      dotsContainer.addEventListener('click', function (e) {
        var dot = e.target.closest('.slider-counter__link--dots');
        if (!dot || !dotsContainer.contains(dot)) return;
        e.preventDefault();
        e.stopPropagation();
        var allDots = Array.from(dotsContainer.querySelectorAll('.slider-counter__link--dots'));
        var index = allDots.indexOf(dot);
        if (index < 0) return;
        var sliderItems = getSliderItems();
        if (sliderItems.length === 0) return;
        var cols = getEffectiveColumns();
        var slideIndex = index * cols;
        var targetSlide = sliderItems[Math.min(slideIndex, sliderItems.length - 1)];
        var targetLeft = targetSlide.offsetLeft;
        slider.scrollTo({ left: Math.min(targetLeft, getMaxScrollLeft()), behavior: 'smooth' });
      });
    }

    function scheduleLayoutSync() {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        resizeTimer = null;
        syncDotsToLayout();
      }, 150);
    }

    mqDesktop.addEventListener('change', syncDotsToLayout);
    window.addEventListener('resize', scheduleLayoutSync);

    syncDotsToLayout();

    if (autoplaySpeed > 0) {
      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }
      function startAutoplay() {
        stopAutoplay();
        autoplayTimer = setInterval(function () {
          if (isAtEnd()) {
            slider.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            nextBtn.click();
          }
        }, autoplaySpeed);
      }
      startAutoplay();
      sliderComponent.addEventListener('mouseenter', stopAutoplay);
      sliderComponent.addEventListener('mouseleave', function () {
        if (autoplaySpeed > 0) startAutoplay();
      });
      sliderComponent.addEventListener('focusin', stopAutoplay);
      sliderComponent.addEventListener('focusout', function () {
        if (autoplaySpeed > 0) startAutoplay();
      });
    }
  }

  window.initFeaturedCollectionSlider = initFeaturedCollectionSlider;

  function initAll() {
    document.querySelectorAll('.featured-collection-section slider-component').forEach(initFeaturedCollectionSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.featured-collection-section slider-component');
    if (section) initFeaturedCollectionSlider(section);
  });
})();
